import { CompositeLensProduct, LensOption, CompositeLensProductType, GlassesZState, ProductFeatureBoxProps, CompositeLensVariationType, CompositeComponentType } from 'constants/dataTypes';
import { frameSizeConst } from 'constants/frameSize';
import { checkUpdateData } from 'functions/checkValidUpdate';
import { getAvailibility } from 'functions/getAvailibility';
import { getTreatmentVariation } from 'functions/getVariations';
import { slugToString } from 'functions/slug';
import { BackgroundColor, generateGlassesImage } from 'utils/image.utils';
import { create } from 'zustand'
import { useRouter } from 'next/router';

const selectLensComponentByPurpose = (purposeVal: string | null): any => {

  if (!purposeVal) return null;
  if (purposeVal === 'multifocal') {
    return 'multifocal-lenses';
  }
  else if (purposeVal == 'non-prescription') {
    return 'plano-lenses';
  } else if (purposeVal == 'sunglasses') {
    return 'plano-lenses';
  }
  else if (purposeVal === 'bifocal') {
    return 'bifocal-lenses';
  }
  else if (purposeVal === 'go-reading' || purposeVal === 'go-polarised' || purposeVal === 'go-blue-light-filter') {
    return 'dresdengo-lenses';
  }
  else if (purposeVal == 'reading' || purposeVal == 'distance') {  //distance, reading
    return 'single-vision-lenses';
  }
  return null;
}

//filter products by slug use lens_component
export const getPurposeOptionList = (category: string, lensProducts: CompositeLensProduct[] | null, featureCache: Map<string, ProductFeatureBoxProps>): LensOption[] => {
  //console.log('getPurposeOptionList category', category);
  //console.log('getPurposeOptionList category', lensProducts);
  if (!category) return [];
  if (!lensProducts) return [];
  let purposeList = [{ 'slug': 'distance', 'lensType': "single-vision-lenses" },
  { 'slug': 'reading', 'lensType': "single-vision-lenses" },
  { 'slug': 'multifocal', 'lensType': "multifocal-lenses" },
  { 'slug': 'bifocal', 'lensType': "bifocal-lenses" },
  { 'slug': 'non-prescription', 'lensType': "plano-lenses" },
  { 'slug': 'sunglasses', 'lensType': "sunglasses" }];


  const purposeOptionList: LensOption[] = [];

  if (category === 'prescription-sunglasses') {
    //remove slug  non-prescription from purposeList
    purposeList.splice(4, 1);
  }
  else if (category === 'non-prescription-sunglasses') {
    //remove slug distance, reading, multifocal, bifocal from purposeList
    purposeList.splice(0, 4);
  }
  else if (category === 'sunglasses') {
    //remove slug distance, reading, multifocal, bifocal from purposeList
    purposeList.splice(0, 4);
  }
  else if (category === 'prescription-glasses') {
    //remove slug non-prescription from purposeList
    purposeList.splice(4, 1);
  }
  else if (category === 'blue-light-filter-glasses') {
    //remove slug distance, reading, multifocal, bifocal from purposeList
    purposeList.splice(0, 4);
  }
  else if (category === 'reading-glasses') {
    //remove slug non-prescription from purposeList
    purposeList = [{ 'slug': 'go-reading', 'lensType': "dresdengo-lenses" }];
  }

  //console.log('lensProducts', lensProducts);
  //console.log('getPurposeOptionList purposeList', purposeList)
  //console.log('getPurposeOptionList lensProducts', lensProducts)
  purposeList.map((purposeItem) => {

    const lensProduct = lensProducts.filter((product) => {
      return product.slug === purposeItem.lensType
    });
    //console.log('purposeItem.lensType', purposeItem.lensType, lensProduct.length)
    if (lensProduct.length > 0) {
      const lensProductItem = lensProduct[0];
      let purposeNaming = "";
      if (featureCache.has(purposeItem.slug)) {
        const feature = featureCache.get(purposeItem.slug);
        if (feature) {
          purposeNaming = feature.title;
        }
      }

      let description = '';
      if (lensProductItem.price.min == lensProductItem.regular_price.min) {
        description = '$' + lensProductItem.price.min;
      }
      else {
        //add css for strike through for regular price with tailwindcss
        //to handle discount prices
        description = `<span class="font-medium text-brand-green">$${lensProductItem.price.min}</span>  <span style="text-decoration: line-through" class="text-[#959595]"> $${lensProductItem.regular_price.min}</span>`;
      }
      //If there is a price range, add "From" to the description
      if (lensProductItem.regular_price.min < lensProductItem.regular_price.max) {
        description = "From " + description;
      }


      purposeOptionList.push({ name: purposeNaming, slug: purposeItem.slug, price: lensProductItem.price.min, selected: false, regular_price: lensProductItem.regular_price.min, regular_price_max: lensProductItem.regular_price.max, description: description, status: true });

    }



  });


  return purposeOptionList;

};

export const generateGlassessImages = (frameColourSlug: string, armColourSlug: string, lensColor: string): string[] => {
  const imageIndexList = ['0', '3', '1', '2'];
  return imageIndexList.map((index) => {
    return generateGlassesImage(frameColourSlug, armColourSlug, index, lensColor, BackgroundColor.Grey);
  });
}

const getVariationAttributeSlugSection = (attributeValue: string | undefined) => {
  if (attributeValue) {
    return '+' + attributeValue;
  }
  return '';
}

const getMetaSlug = (lensVariation: CompositeLensVariationType) => {
  if (lensVariation.meta) {
    return lensVariation.meta.attribute_pa_treatment
      + getVariationAttributeSlugSection(lensVariation.meta.attribute_pa_lens_thickness)
      + getVariationAttributeSlugSection(lensVariation.meta.attribute_pa_stock_type)
  }
  //return / for no meta
  return '/';
}


const getOptionDescription = (price: number, regular_price: number, category_min_price: number, category_min_regular_price: number) => {
  const priceDiff = parseFloat((price - category_min_price).toFixed(2));
  if (priceDiff < 1) {
    return 'No extra fee';
  }

  if (price == regular_price) {
    return '+ $' + priceDiff;
  } else {
    return `<span class="text-[#959595]">+ </span><span class="font-medium text-brand-green">$${priceDiff}</span>  <span style="text-decoration: line-through" class="text-[#959595]"> $${(regular_price - category_min_regular_price)}</span>`;
  }
}

export const getLensThicknessOptionList = (lensComponent: string | null, lensProducts: CompositeLensProduct[] | null, lensOptions: LensOption[] | undefined, featureCache: Map<string, ProductFeatureBoxProps>, shape: string): LensOption[] => {
  if (!lensComponent) return [];
  if (!lensProducts) return [];
  if (!lensOptions) return [];

  let lensOptionSlug = '';
  if (lensOptions.length > 1) {
    lensOptions.map((option) => {
      if (option.selected) {
        lensOptionSlug = option.slug;
      }
    });
  } else if (lensOptions.length == 1) {
    lensOptionSlug = lensOptions[0].slug;
  }


  const lensThicknessOptionList: LensOption[] = [];

  //If no lens option is selected, return empty list
  if (lensOptionSlug === '') return lensThicknessOptionList;


  lensProducts.filter((product) => {
    return product.slug === lensComponent
  }).map((product) => {

    let variationCategoryPrice = { price: 0, regular_price: 0 };
    product.variations.map((lensVariation: CompositeLensVariationType) => {
      if (lensVariation.meta.attribute_pa_treatment.toLowerCase() == lensOptionSlug.toLowerCase() && lensVariation.meta.attribute_pa_frame_shape.includes(shape.toLowerCase())) {
        //We want to get the min price for the lens option
        if (variationCategoryPrice.price === 0 || variationCategoryPrice.price > lensVariation.meta.price) {
          variationCategoryPrice = { price: lensVariation.meta.price, regular_price: lensVariation.meta.regular_price };
        }
      }
    });
    return product.variations.map((lensVariation: CompositeLensVariationType) => {
      //Check if the lens variation is for the selected lens option
      // if (process.env.NEXT_PUBLIC_ENV == 'development') {
      //   if (lensVariation.meta.attribute_pa_frame_shape !== 'classic') {
      //     console.log('lensVariation', lensVariation);
      //     return;
      //   }
      // }

      if (lensVariation.meta.attribute_pa_treatment.toLowerCase() == lensOptionSlug.toLowerCase() && lensVariation.meta.attribute_pa_frame_shape.includes(shape.toLowerCase())) {

        let lensNaming = "";
        const lensNotionSlug = getMetaSlug(lensVariation);
        if (featureCache && featureCache.has(lensNotionSlug)) {
          const feature = featureCache.get(lensNotionSlug);
          if (feature) {
            lensNaming = feature.title;
          }
        } else {
          // Slug to titlelensVariation.meta.attribute_pa_lens_thickness
          lensNaming = slugToString(lensVariation.meta.attribute_pa_lens_thickness);
        }
        const lensOptionSlug = lensVariation.meta.attribute_pa_lens_thickness;
        lensVariation.product_id = product.product_id;
        if (lensOptionSlug !== undefined) {
          let description = getOptionDescription(lensVariation.meta.price, lensVariation.meta.regular_price, variationCategoryPrice.price, variationCategoryPrice.regular_price);
          if (lensVariation.meta.attribute_pa_stock_type == 'grind') {
            description = description + '';
          }
          if ((lensVariation.isAvailable == undefined || lensVariation.isAvailable)) {
            const lensThicknessOption: LensOption = { name: lensNaming, slug: lensOptionSlug, price: lensVariation.meta.price, selected: false, regular_price: lensVariation.meta.regular_price, variation: lensVariation, description: description, status: true };
            //Check if the lens option is already in the lensThicknessOptionList
            const lensThicknessOptionIndex = lensThicknessOptionList.findIndex((lensThicknessOption) => lensThicknessOption.slug === lensOptionSlug);
            if (lensThicknessOptionIndex === -1) {
              lensThicknessOptionList.push(lensThicknessOption);
            } else {
              //If the current lens variation is cheaper than the one in the list, replace it
              //TODO: add check for single vision lenses availability for grind stock types
              // if (lensThicknessOptionList[lensThicknessOptionIndex].regular_price > lensVariation.meta.regular_price) {
              lensThicknessOptionList[lensThicknessOptionIndex].regular_price = lensVariation.meta.regular_price;
              lensThicknessOptionList[lensThicknessOptionIndex].price = lensVariation.meta.price;
              lensThicknessOptionList[lensThicknessOptionIndex].variation = lensVariation;
              lensThicknessOptionList[lensThicknessOptionIndex].status = true;
              lensThicknessOptionList[lensThicknessOptionIndex].description = description;
              lensThicknessOptionList[lensThicknessOptionIndex].variation = lensVariation;
              // }
            }
          } else {
            const lensThicknessOption: LensOption = { status: false, name: lensNaming, slug: lensOptionSlug, price: lensVariation.meta.price, selected: false, regular_price: lensVariation.meta.regular_price, variation: lensVariation, description: description };
            const lensThicknessOptionIndex = lensThicknessOptionList.findIndex((lensThicknessOption) => lensThicknessOption.slug === lensOptionSlug);
            if (lensThicknessOptionIndex === -1) {
              lensThicknessOptionList.push(lensThicknessOption);
            }
          }

        }
        else { //For non-prescription lenses
          const lensThicknessOption: LensOption = { name: lensNaming, slug: lensComponent, price: lensVariation.meta.price, selected: false, regular_price: lensVariation.meta.regular_price, variation: lensVariation, description: '', status: true };
          lensThicknessOptionList.push(lensThicknessOption);
        }
        //
      }
    });
  });

  //Sort lensThicknessOptionList by slug alphabetically
  lensThicknessOptionList.sort((a, b) => {
    if (a.slug < b.slug) return -1;
    if (a.slug > b.slug) return 1;
    return 0;
  });
  return lensThicknessOptionList;
};

export const getLensOptionItem = (featureCache: Map<string, ProductFeatureBoxProps>, optionSlug: string, itemPrice: number, itemRegularPrice: number, categoryPrice: number, categoryRegularPrice: number): LensOption => {
  let lensNaming = "";
  let sortIndex = 0;

  try {
    if (featureCache.has(optionSlug)) {
      const feature = featureCache.get(optionSlug);
      if (feature) {
        lensNaming = feature.title;
        sortIndex = feature.sortIndex;
      }
    }

    if (lensNaming === "") {
      lensNaming = slugToString(optionSlug);
    }

    const description = getOptionDescription(itemPrice, itemRegularPrice, categoryPrice, categoryRegularPrice);

    // Normalize polarised mirror tint names
    if (/^Polarised (Grey|Brown|Green|Blue) Mirror$/.test(lensNaming)) {
      lensNaming = 'Polarised Mirror Tint';
    }

    return {
      name: lensNaming,
      sortIndex,
      slug: optionSlug,
      price: itemPrice,
      selected: false,
      regular_price: itemRegularPrice,
      description,
      status: true
    };
  } catch (error) {
    console.error('Error in getLensOptionItem:', error);

    // Return a fallback option with the slug as name if something fails
    return {
      name: optionSlug,
      sortIndex: 0,
      slug: optionSlug,
      price: itemPrice,
      selected: false,
      regular_price: itemRegularPrice,
      description: getOptionDescription(itemPrice, itemRegularPrice, categoryPrice, categoryRegularPrice),
      status: true
    };
  }
};

export const getLensColorOptionList = (lensComponent: string | null, lensProducts: CompositeLensProduct[] | null, lensOptions: LensOption[] | undefined, featureCache: Map<string, ProductFeatureBoxProps>): LensOption[] => {
  if (!lensComponent) return [];
  if (!lensProducts) return [];
  if (!lensOptions) return [];
  //console.log('getLensColorOptionList : lensProducts', lensProducts);
  //console.log('getLensColorOptionList : lensComponent', lensComponent);
  //console.log('getLensColorOptionList : lensOptions', lensOptions);

  let lensOptionSlug = '';
  lensOptions.map((option) => {
    if (option.selected) {
      lensOptionSlug = option.slug;
    }
  });

  const lensColorOptionList: LensOption[] = [];

  //If no lens option is selected, return empty list
  if (lensOptionSlug === '') return lensColorOptionList;

  const lensColorOptionMap = new Map<string, LensOption>();
  const lensColorOptionMapNotAv = new Map<string, LensOption>();

  lensProducts.filter((product) => {
    return product.slug === lensComponent
  }).map((product) => {
    //console.log('getLensColorOptionList : product', product);

    let variationCategoryPrice = { price: 0, regular_price: 0 };
    product.variations.map((lensVariation: CompositeLensVariationType) => {
      //We want to get the min price for the lens option
      if (variationCategoryPrice.price === 0 || variationCategoryPrice.price > lensVariation.meta.price) {
        variationCategoryPrice = { price: lensVariation.meta.price, regular_price: lensVariation.meta.regular_price };
      }
    });
    return product.variations.map((lensVariation: CompositeLensVariationType) => {
      //Check if the lens variation is for the selected lens option
      if (getTreatmentVariation(lensVariation.meta.attribute_pa_treatment, lensOptionSlug)) {

        if (lensColorOptionMap.has(lensVariation.meta.attribute_pa_treatment)) {
          const lensColorOptionItem = lensColorOptionMap.get(lensVariation.meta.attribute_pa_treatment);
          if (lensColorOptionItem && lensColorOptionItem?.regular_price! > lensVariation.meta.regular_price) {
            lensColorOptionItem.regular_price = lensVariation.meta.regular_price;
            lensColorOptionItem.price = lensVariation.meta.price;
            lensColorOptionItem.description = getOptionDescription(lensVariation.meta.price, lensVariation.meta.regular_price, variationCategoryPrice.price, variationCategoryPrice.regular_price);
            lensColorOptionMap.set(lensVariation.meta.attribute_pa_treatment, lensColorOptionItem);
          }
          return;
        }

        const lensColorOption = getLensOptionItem(featureCache, lensVariation.meta.attribute_pa_treatment, lensVariation.meta.price, lensVariation.meta.regular_price, variationCategoryPrice.price, variationCategoryPrice.regular_price);
        lensColorOptionMap.set(lensVariation.meta.attribute_pa_treatment, lensColorOption);
      }
    });
  });

  lensColorOptionMap.forEach((lensColorOption,) => {
    lensColorOptionList.push(lensColorOption);
  });

  if (lensColorOptionList.length == 0) {
    lensColorOptionMapNotAv.forEach((lensColorOption,) => {
      lensColorOptionList.push(lensColorOption);
    });
  }

  lensColorOptionList.sort((a, b) => {
    if (a.sortIndex && b.sortIndex) {
      if (a.sortIndex < b.sortIndex) return -1;
      if (a.sortIndex > b.sortIndex) return 1;
    }
    return 0;
  });

  return lensColorOptionList;
};

export const processLensColorForDisplay = (lensColor: string | null | undefined): string => {
  if (!lensColor) return 'clear';
  if (lensColor == 'blue-light-filter') return 'clear';

  return lensColor.replace('sun-glasses-', '').replace('polarised-', '').replace('photochromic-', '').replace('mirror-tint', 'mirror');

}

//filter products by slug use lens_component
export const getLensTypeOptionList = (lensType: string | null, lensProducts: CompositeLensProduct[] | null, featureCache: Map<string, ProductFeatureBoxProps>): LensOption[] => {
  if (!lensType) return [];
  if (!lensProducts) return [];
  // console.log('lensProducts', lensProducts);
  //console.log('lensType', lensType);
  const lensProductsFiltered: LensOption[] = lensProducts.filter((product) => {
    return product.slug === lensType
  }).map((product) => {
    // console.log('getLensTypeOptionList product', product);
    return product.lens_types.map((lensProductType: CompositeLensProductType) => {
      return getLensOptionItem(featureCache, lensProductType.type, lensProductType.price, lensProductType.regular_price, product.price.min, product.regular_price.min);
    });
  }).reduce((acc, current) => acc.concat(current), []);

  let allItemsHasSamePrice = false;
  //Check if all items in lensProductsFiltered has same .price
  const lensProductsFilteredPrice = lensProductsFiltered.map((lensProduct) => lensProduct.price);
  const lensProductsFilteredPriceSet = new Set(lensProductsFilteredPrice);
  if (lensProductsFilteredPriceSet.size === 1) {
    //All items in lensProductsFiltered has same .price
    //console.log(('lensProductsFiltered items has same price');
    allItemsHasSamePrice = true;
  }


  //console.log('lensProductsFiltered', lensProductsFiltered);
  return lensProductsFiltered.sort((a: LensOption, b: LensOption) => {

    if (!allItemsHasSamePrice) {
      if (a.price > b.price) return 1;
      if (b.price > a.price) return -1;
    }
    if (a.sortIndex && b.sortIndex) {
      if (a.sortIndex < b.sortIndex) return -1;
      if (a.sortIndex > b.sortIndex) return 1;
    }

    return 0;
  });
};

export const useGlassesStore = create<GlassesZState>((set) => ({
  category: '', //glasses, sunglasses
  category_display: '',
  frame_color: '',
  frame_color_display: '',
  frame_size: 'M', //xsmall, small, medium, large
  arms_color: '',
  arms_size: 'M', //xsmall, small, medium, large
  is_arm_customized: false,
  is_variant_available: false,
  is_prescription_lens: false,
  arm_main_products: null,
  is_availibility_loading: false, //
  prescription_email: false,
  skip_pd: false,
  have_us_call_optometrist: false,
  selectedPD: null,
  setSelectedPD: (selectedPD: any) => set((state) => ({
    ...state,
    selectedPD: selectedPD
  })),
  setHaveUsCallOptometrist: (have_us_call_optometrist: any) => set((state) => ({
    ...state,
    have_us_call_optometrist: have_us_call_optometrist
  })),
  setAvailibilityLoading: (availibility_loading: any) => set((state) => ({
    ...state,
    is_availibility_loading: availibility_loading
  })),
  setPrescriptionEmail: (email: any) => set((state) => ({
    ...state,
    prescription_email: email
  })),
  setSkipPd: (skip_pd: any) => set((state) => ({
    ...state,
    skip_pd: skip_pd
  })),
  availibility: undefined, //
  lens_options: undefined, //
  setAvailibility: (availibility: any) => set((state) => {
    const updatedObject = {
      ...state,
      availibility: availibility,
      lens_products: getAvailibility(availibility, state.lens_main_products!, state.have_us_call_optometrist, state.prescription_email),
      lens_thickness_selected: null,
      lens_color_selected: null,
    };
    return updatedObject;
  }),

  purpose: null,  //Distance, Reading, Multifocal, Non-Prescription
  purpose_option: undefined,
  purpose_options: undefined, //Distance, Reading, Multifocal, Non-Prescription
  lens_component: 'plano-lenses', //single vision, plano, bifocal, multifocal
  lens_color_options: undefined, //
  lens_thickness_options: undefined, //
  lens_color_display: null, //
  lens_color_selected: null, //Clear, Brown, Grey, Green, Mirror, Blue Light Filter
  lens_thickness_selected: null, //Standard, Thin, Thinner, Thinnest
  lens_type_selected: null, //stock,grind for only single vision lenses
  lens_main_products: null,
  lens_products: null, //
  frame_main_products: null, //
  prescription: null, //from prescriptions
  updateData: null,

  setVariantAvailable: (isAvailable: boolean) => set((state) => ({
    ...state,
    is_variant_available: isAvailable
  })),
  setArmCustomized: (isCustomized: boolean) => set((state) => ({
    ...state,
    is_arm_customized: isCustomized,
    arms_color: isCustomized ? state.arms_color : state.frame_color,
    arms_size: isCustomized ? state.arms_size : state.frame_size,
  })),
  setFrameColor: (color: string) => set((state) => ({
    ...state,
    frame_color: color,
  })),
  setFrameColorDisplay: (color: string) => set((state) => ({
    ...state,
    frame_color_display: color,
  })),
  setArmsColor: (color: string) => set((state) => ({
    ...state,
    arms_color: color,
  })),
  setFrameSize: (size: string) => set((state) => ({
    ...state,
    frame_size: size,
  })),
  setArmsSize: (size: string) => set((state) => ({
    ...state,
    arms_size: size,
  })),
  setFrameArmsSize: (size: string) => set((state) => ({
    ...state,
    frame_size: size,
    arms_size: size,
  })),
  setFrameArmsColor: (color: string) => set((state) => ({
    ...state,
    frame_color: color,
    arms_color: color,
  })),
  setUpdateGlasses: (glasses: any) => set((state) => ({
    ...state,
    updateData: glasses
  })),
  setCategory: (cat: string, productColor: string, products: CompositeComponentType, featureCache: Map<string, ProductFeatureBoxProps>, initialShape: string = 'classic') => set(state => {
    //console.log('setCategory', cat);
    console.log('setCategory products.Lens.products', products.Lens.products);
    const purposeOptions = getPurposeOptionList(cat, products.Lens.products, featureCache);
    if (purposeOptions.length == 1) {
      purposeOptions[0].selected = true;
    }
    let lensColorValue = null;
    if (cat.includes('sunglasses')) {
      lensColorValue = 'grey';
    }

    let isPrescriptionLens = true;
    if (cat == 'non-prescription-sunglasses' || cat == 'blue-light-filter-glasses' || cat == 'reading-glasses' || cat == 'sunglasses') {
      isPrescriptionLens = false;
    }
    const purposeValue = purposeOptions.length == 1 ? purposeOptions[0].slug : null;

    if (checkUpdateData(state.updateData, cat, productColor)) {
      var isArmCustomized = false;
      if (state.updateData.glassesData.armColor !== state.updateData.glassesData.frameColor
        || state.updateData.glassesData.armSize !== state.updateData.glassesData.frameSize) {
        isArmCustomized = true;
      }

      var armSize = frameSizeConst.map((size) => {
        if (size.slug === state.updateData.glassesData.armSize) {
          return size.short;
        }
      }).filter((size) => size !== undefined)[0];

      var frameSize = frameSizeConst.map((size) => {
        if (size.slug === state.updateData.glassesData.frameSize) {
          return size.short;
        }
      }).filter((size) => size !== undefined)[0];

      if (frameSize === undefined && state.updateData.glassesData.frameSize.includes('round')) {
        frameSize = state.updateData.glassesData.frameSize.replace('round', '').toUpperCase();
      }

      if (state.frame_size !== undefined) {
        frameSize = state.frame_size;
      }

      if (state.arms_size !== undefined) {
        armSize = state.arms_size;
      }

      var lensComponent = selectLensComponentByPurpose(state.updateData.glassesData.purpose);
      var lensOptions = getLensTypeOptionList(lensComponent, products.Lens.products, featureCache);
      var lensColorOption = getLensColorOptionList(lensComponent, products.Lens.products, lensOptions, featureCache);
      const updatedState = {
        ...state,
        category: cat,
        category_display: slugToString(cat),
        lens_products: products.Lens.products,
        lens_main_products: products.Lens,
        frame_main_products: products.Frame,
        arm_main_products: products.Arms,
        is_arm_customized: isArmCustomized,
        frame_color: state.updateData.glassesData.frameColor,
        arms_color: state.updateData.glassesData.armColor,
        frame_size: frameSize,
        arms_size: armSize,
        is_prescription_lens: isPrescriptionLens,
        purpose_options: purposeOptions.map((option) => {
          if (option.slug == state.updateData.glassesData.purpose) {
            option.selected = true;
            state.purpose = option.slug;
          }
          return option;
        }),
        purpose: state.updateData.glassesData.purpose,
        purpose_option: state.purpose_options?.filter((option) => {
          if (option.slug == state.updateData.glassesData.purpose) {
            return option;
          }
        })[0],
        lens_component: lensComponent,
        lens_type_selected: state.updateData.glassesData.lensType,
        lens_options: lensOptions.map((option) => {
          if (option.slug === state.updateData.glassesData.lensType) {
            option.selected = true;
          }

          return option;
        }),
        lens_color_options: lensColorOption.map((option) => {
          if (option.slug === state.updateData.glassesData.lensType) {
            option.selected = true;
          }
          return option;
        }),
        lens_color_selected: state.updateData.glassesData.lensType,
        lens_color_display: processLensColorForDisplay(state.updateData.glassesData.lensType),
        frame_shape: initialShape,
      };

      //console.log('updateee updatedState', updatedState);
      return updatedState;
    } else {
      const updatedState = {
        ...state,
        category: cat,
        category_display: slugToString(cat),
        lens_products: products.Lens.products,
        lens_main_products: products.Lens,
        frame_main_products: products.Frame,
        arm_main_products: products.Arms,
        is_arm_customized: false,
        is_prescription_lens: isPrescriptionLens,
        lens_options: undefined,
        frame_color: productColor,
        arms_color: state.arms_color ? state.arms_color : productColor,
        lens_color_options: undefined, //
        lens_color_selected: lensColorValue,
        lens_color_display: processLensColorForDisplay(lensColorValue),
        lens_thickness_options: undefined, //
        lens_thickness_selected: null,
        lens_type_selected: null,
        purpose: purposeValue,
        purpose_option: purposeOptions.length > 0 ? purposeOptions[0] : undefined,
        lens_component: selectLensComponentByPurpose(purposeValue),
        purpose_options: purposeOptions,
        updateData: null,
        frame_shape: initialShape,
      };

      //console.log('updatedState', updatedState);

      return updatedState;
    }
  }),
  setFrameCategory: (cat: string, productColor: string, products: CompositeComponentType) => set(state => {
    if (state.updateData !== null) {
      var isArmCustomized = false;
      if (state.updateData.frameData.armColor !== state.updateData.frameData.frameColor
        || state.updateData.frameData.armSize !== state.updateData.frameData.frameSize) {
        isArmCustomized = true;
      }
      var armSize = frameSizeConst.map((size) => {
        if (size.slug === state.updateData.frameData.armSize) {
          return size.short;
        }
      }).filter((size) => size !== undefined)[0];

      var frameSize = frameSizeConst.map((size) => {
        if (size.slug === state.updateData.frameData.frameSize) {
          return size.short;
        }
      }).filter((size) => size !== undefined)[0];

      const updatedState = {
        ...state,
        category: cat,
        category_display: slugToString(cat),
        frame_main_products: products.Frame,
        arm_main_products: products.Arms,
        is_arm_customized: isArmCustomized,
        frame_color: state.updateData.frameData.frameColor,
        arms_color: state.updateData.frameData.armColor,
        frame_size: frameSize,
        arms_size: armSize,
        lens_color_display: 'clear'
      };

      //console.log('updateee updatedState', updatedState);
      return updatedState;
    } else {
      const updatedState = {
        ...state,
        category: cat,
        category_display: 'Frame Set',
        frame_main_products: products.Frame,
        arm_main_products: products.Arms,
        is_arm_customized: false,
        is_prescription_lens: false,
        lens_options: undefined,
        frame_color: productColor,
        arms_color: productColor,
        lens_color_display: 'clear'
      };

      return updatedState;
    }
  }),
  setLensThicknessOptions: (options: LensOption[]) => set((state) => {
    const updatedState = {
      ...state,
      lens_thickness_options: options,
      lens_thickness_selected: null
    };

    return updatedState;
  }),
  setLensThicknessGroup: (group: LensOption | undefined) => set((state) => ({
    ...state,

    lens_thickness_options: state.lens_thickness_options?.map((option) => {
      if (option.slug == group?.slug) {
        option.selected = true;
      }
      else {
        option.selected = false;
      }
      return option;
    }),
    lens_variation: group,
    lens_thickness_selected: group
  })),

  setLensColor: (lens_color: string) => set((state) => ({
    ...state,
    lens_color_display: lens_color,
  })),

  setLensColorOptions: (options: LensOption[]) => set((state) => ({
    ...state,
    lens_color_options: options
  })),
  setLensColorGroup: (group: LensOption | undefined) => set((state) => ({
    ...state,

    lens_color_options: state.lens_color_options?.map((option) => {
      if (option.slug == group?.slug) {
        option.selected = true;
      }
      else {
        option.selected = false;
      }
      return option;
    }),
    lens_color_selected: group?.slug,
    lens_color_display: processLensColorForDisplay(group?.slug),

  })),

  setLensOptions: (options: LensOption[] | undefined) => set((state) => ({
    ...state,
    lens_options: options,
    lens_type_selected: null
  })),
  setLensOptionGroup: (group: LensOption | undefined) => set((state) => ({
    ...state,
    lens_options: state.lens_options?.map((option) => {
      if (option.slug == group?.slug) {
        //console.log('setLensOptionGroup', option.slug, group?.slug);
        option.selected = true;
      }
      else {
        option.selected = false;
      }
      return option;
    }),
    lens_type_selected: group?.slug

  })),


  setPurpose: (purposeVal: LensOption | undefined) => set((state) => ({
    ...state,
    purpose_options: state.purpose_options?.map((option) => {
      if (option.slug == purposeVal?.slug) {
        option.selected = true;
        //console.log('setPurpose store', purposeVal?.slug)
        state.purpose = option.slug;
      }
      else {
        option.selected = false;
      }
      return option;
    }),
    purpose: purposeVal?.slug,
    purpose_option: purposeVal,
    lens_component: selectLensComponentByPurpose(purposeVal?.slug!),

  })),

  frame_shape: 'classic',

  setFrameShape: (shape: string) => set((state) => ({
    ...state,
    frame_shape: shape,
  })),
  setIsPrescriptionLens: (isPrescriptionLens: boolean) => set((state) => ({
    ...state,
    is_prescription_lens: isPrescriptionLens
  })),
}))
